import React, { Component } from 'react';
import { FaPhoneSlash, FaPauseCircle } from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import AddButton from '../addButton';

import 'react-datepicker/dist/react-datepicker.css';



class WinningNumbers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmAction: '', // '' | 'save'
            originalTempData: null,
            editData: false,
            filterBy: {},
            sortBy: 'drawDate',
            sortOrder: 1,
            loading: false,
            category: ''
        };
    }
    cancel = () => {
        this.setState({ editData: false, tempData: false, originalTempData: null, confirmAction: '', loading: false, error: '' })
    }

    cancelConfirm = () => {
        this.setState({ confirmAction: '', error: '' });
    };
    editData = (id) => e => {
        var item = this.props.data.WinningNumbers.data.find(function (element) {
            return element.id === id;
        });

        // Clone so we don't mutate props, and keep an original snapshot for the confirm modal
        const temp = item ? JSON.parse(JSON.stringify(item)) : null;

        this.setState({
            editData: true,
            tempData: temp,
            originalTempData: temp ? JSON.parse(JSON.stringify(temp)) : null,
            loading: false,
            error: ''
        })
    }

    addWinningNumber = () => {
        const gamesObj = (this.props.data && this.props.data.WinningNumbers && this.props.data.WinningNumbers.settings && this.props.data.WinningNumbers.settings.Games)
            ? this.props.data.WinningNumbers.settings.Games
            : {};

        const gameKey = (this.state.category && gamesObj[this.state.category]) ? this.state.category : (Object.keys(gamesObj)[0] || '');
        const gameDef = (gameKey && gamesObj[gameKey]) ? gamesObj[gameKey] : null;

        // Compute default drawId as today's date in YYMMDD format
        const now = new Date();
        const yy = String(now.getFullYear()).slice(-2);
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const dd = String(now.getDate()).padStart(2, '0');
        const defaultDrawId = `${yy}${mm}${dd}`;

        // Auto-populate draw date with today if it's a valid draw day
        let defaultDrawDate = '';
        const todayWeekday = now.toLocaleDateString(undefined, { weekday: 'long' });
        if (!gameDef || !Array.isArray(gameDef.drawDays) || gameDef.drawDays.includes(todayWeekday)) {
            const yyyy = String(now.getFullYear());
            defaultDrawDate = `${yyyy}-${mm}-${dd}`;
        }

        // Create a new blank record for the selected game (same edit UX as clicking an existing row)
        const temp = {
            id: null, // backend can compute/assign based on game+drawId, etc.
            game: gameKey,
            gameName: (gameDef && gameDef.Name) ? gameDef.Name : gameKey,
            drawId: defaultDrawId,
            drawDate: defaultDrawDate,
            numbers: {},
            disableImporterUpdates: false,
            doNotPlayOnIVR: false
        };

        this.setState({
            editData: true,
            tempData: temp,
            originalTempData: null, // null => treated as "new" in the confirm summary
            confirmAction: '',
            loading: false,
            error: ''
        });
    }
    // add = () => {
    //     this.setState({ editData: true, promptID: null, loading: false, error: '' })
    // }

    checkEnter = (e) => {
        if (e.keyCode === 13) {
            this.confirmEdit();
        }
    }
    toggle = (param) => (e) => {
        var newState = Object.assign({}, this.state)
        newState[param] = this.state[param] ? false : true
        this.setState(newState)
    }
    componentWillReceiveProps(nextProps) {
        if (this.state.loading) {
            this.cancel()
        }
    }

    handleBallValueChange = (ballId, min, max) => (e) => {
        const raw = e.target.value;

        this.setState(prevState => {
            const updatedTempData = { ...prevState.tempData };
            updatedTempData.numbers = { ...(updatedTempData.numbers || {}) };

            // Allow clearing
            if (raw === '' || raw === null || raw === undefined) {
                delete updatedTempData.numbers[ballId];
                return { tempData: updatedTempData };
            }

            // Store as number when possible
            const parsed = Number(raw);
            updatedTempData.numbers[ballId] = parsed;

            return { tempData: updatedTempData };
        });
    }

    handleTempDataValueChange = (e, index) => {
        const newValue = e.target.value;

        this.setState(prevState => {
            const updatedTempData = { ...prevState.tempData };
            if (Array.isArray(updatedTempData.value)) {
                updatedTempData.value[index] = newValue;
            } else {
                updatedTempData.value = newValue;
            }
            return { tempData: updatedTempData };
        });
    }

    handleDrawIdChange = (e) => {
        const newValue = e.target.value;
        this.setState(prevState => ({
            tempData: {
                ...prevState.tempData,
                drawId: newValue
            }
        }));
    }

    handleDrawDateChange = (e) => {
        const newValue = e.target.value;
        this.setState(prevState => ({
            tempData: {
                ...prevState.tempData,
                // store as a string; backend/formatDrawDate can parse common ISO formats
                drawDate: newValue
            }
        }));
    }

    handleDisableImporterUpdatesChange = (e) => {
        const checked = !!e.target.checked;
        this.setState(prevState => ({
            tempData: {
                ...prevState.tempData,
                disableImporterUpdates: checked
            }
        }));
    }

    handleDoNotPlayOnIVRChange = (e) => {
        const checked = !!e.target.checked;
        this.setState(prevState => ({
            tempData: {
                ...prevState.tempData,
                doNotPlayOnIVR: checked
            }
        }));
    }
    toggleTempDataValue = (e) => {
        this.setState(prevState => {
            const updatedTempData = { ...prevState.tempData };
            updatedTempData.value = !updatedTempData.value;
            return { tempData: updatedTempData };
        })
    }

    confirmEdit = (action = 'save') => {
        this.setState({ confirmAction: action, error: '' });
    };
    finalizeDelete = () => {
        this.setState({ loading: true });

        const tempData = this.state.tempData || {};
        const original = this.state.originalTempData || null;

        // Prefer original id/drawId in case user edited fields before deleting
        const payload = original ? JSON.parse(JSON.stringify(original)) : JSON.parse(JSON.stringify(tempData));

        // Ensure the backend can locate the row even if drawId was changed
        payload.originalDrawId = (original && original.drawId) ? original.drawId : (tempData.drawId || null);

        this.props.ws.send(JSON.stringify({ route: 'deleteWinningNumbers', data: payload }));
        this.setState({ confirmAction: '', editData: false, loading: true, tempData: null, originalTempData: null, error: '' });
    };

    // your existing confirmEdit logic becomes finalizeEdit
    finalizeEdit = () => {
        // PUT your current confirmEdit validation + ws.send here
        this.setState({ loading: true })

        const tempData = this.state.tempData;
        const gamesObj = (this.props.data && this.props.data.WinningNumbers && this.props.data.WinningNumbers.settings && this.props.data.WinningNumbers.settings.Games)
            ? this.props.data.WinningNumbers.settings.Games
            : {};

        const gameKey = tempData && tempData.game ? tempData.game : null;
        const gameDef = (gameKey && gamesObj[gameKey]) ? gamesObj[gameKey] : null;
        const balls = (gameDef && Array.isArray(gameDef.Balls)) ? gameDef.Balls : [];

        // Validate
        const errors = [];
        const numbers = (tempData && tempData.numbers) ? tempData.numbers : {};

        for (const ball of balls) {
            const id = ball.id;
            const min = (ball.Min !== undefined && ball.Min !== null) ? Number(ball.Min) : null;
            const max = (ball.Max !== undefined && ball.Max !== null) ? Number(ball.Max) : null;
            const val = numbers[id];

            if (val === undefined || val === null || val === '') {
                errors.push(`${ball.Name || id} is required`);
                continue;
            }

            const num = Number(val);
            if (!Number.isFinite(num) || !Number.isInteger(num)) {
                errors.push(`${ball.Name || id} must be an integer`);
                continue;
            }
            if (min !== null && num < min) {
                errors.push(`${ball.Name || id} must be >= ${min}`);
                continue;
            }
            if (max !== null && num > max) {
                errors.push(`${ball.Name || id} must be <= ${max}`);
                continue;
            }
        }

        if (errors.length > 0) {
            this.setState({ loading: false, error: errors[0] })
            return;
        }

        // Pass originalDrawId so the server can update the correct row even if drawId was changed.
        const originalDrawId = (this.state.originalTempData && this.state.originalTempData.drawId)
            ? this.state.originalTempData.drawId
            : (tempData && tempData.drawId ? tempData.drawId : null);

        tempData.lastUpdatedDate = new Date().toJSON();
        tempData.originalDrawId = originalDrawId;

        this.props.ws.send(JSON.stringify({ route: 'updateWinningNumbers', data: tempData }))
        this.setState({ confirmAction: '', editData: false, loading: true, tempData: null, originalTempData: null, error: '' })
    };


    sort = (sortBy) => (e) => {
        var sortOrder
        if (this.state.sortOrder === -1) {
            sortOrder = 1;
        } else {
            sortOrder = -1;
        }
        this.setState({ sortBy: sortBy, sortOrder: sortOrder })
    }

    filter = (field) => (e) => {
        var filterBy = this.state.filterBy
        if (e.target.value.length > 0) {
            filterBy[field] = e.target.value
        } else {
            delete filterBy[field]
        }
        this.setState({ filterBy: filterBy })
    }

    sortFunc(sortBy, sortOrder) {
        return function (a, b) {
            if (sortBy in a && sortBy in b) {
                if (a[sortBy] === b[sortBy]) {
                    // Tie-break by drawId if available
                    const aTie = (a.drawId || '').toString();
                    const bTie = (b.drawId || '').toString();
                    if (aTie === bTie) return 0;
                    return aTie > bTie ? 1 * sortOrder : -1 * sortOrder;
                }
                return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
            }
        }
    }
    checkCategory = (e) => {
        this.setState({ category: e.target.value })
    }
    filterFunc(array, filterBy) {
        return array.filter(function (object) {
            for (var prop in filterBy) {
                if (typeof object[prop] === "undefined") {
                    return false
                }
                if (prop === 'language') {
                    if (object[prop].indexOf(filterBy[prop]) < 0) {
                        return false
                    }

                } else {
                    if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
                        return false
                    }
                }

            }
            return true
        })
    }

    filterIcon(item) {
        return (this.state.sortBy === item ? (this.state.sortOrder == 1) ? " \u25B2" : " \u25BC" : "")
    }

    filterByDropdown = (value) => {
        var filterBy = this.state.filterBy
        if (!value) {
            delete filterBy.is_enabled
        } else if (value.id == 1) {
            filterBy.is_enabled = true
        } else if (value.id == 0) {
            filterBy.is_enabled = false
        }
        this.setState({ filterBy: filterBy })

    }

    render() {
        if (this.props.active) {

            const gamesObj = (this.props.data && this.props.data.WinningNumbers && this.props.data.WinningNumbers.settings && this.props.data.WinningNumbers.settings.Games)
                ? this.props.data.WinningNumbers.settings.Games
                : {};

            const gameKeys = Object.keys(gamesObj);

            // Default to true (kansas) ONLY when the setting is missing; otherwise respect false.
            const importer = (typeof this.props.data.WinningNumbers.settings.importer === 'boolean') ? this.props.data.WinningNumbers.settings.importer : true;
            const deleteOption = (typeof this.props.data.WinningNumbers.settings.delete === 'boolean') ? this.props.data.WinningNumbers.settings.delete : true;
            const showDrawID = (typeof this.props.data.WinningNumbers.settings.drawID === 'boolean') ? this.props.data.WinningNumbers.settings.drawID : true;
            const selectedGame = (this.state.category && gamesObj[this.state.category]) ? gamesObj[this.state.category] : null;
            const selectedBalls = (selectedGame && Array.isArray(selectedGame.Balls)) ? selectedGame.Balls : [];

            const formatMoney = (val) => {
                const num = Number(val);
                if (!Number.isFinite(num)) return val;
                return '$' + num.toLocaleString();
            };

            const renderWinningNumbers = (rec) => {
                if (!rec || !rec.numbers) return null;

                const circleStyle = {
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '28px',
                    height: '28px',
                    borderRadius: '50%',
                    background: '#2A6AA9',
                    color: '#fff',
                    fontWeight: 'bold',
                    marginRight: '5px',
                    marginBottom: '4px',
                    fontSize: '13px',
                    lineHeight: '28px'
                };

                const extraStyle = {
                    display: 'inline-flex',
                    alignItems: 'center',
                    fontSize: '12px',
                    color: '#555',
                    marginRight: '10px',
                    marginBottom: '4px',
                    whiteSpace: 'nowrap'
                };

                return (
                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                        {(() => {
                            const visibleBalls = selectedBalls.filter((ball) => {
                                if (ball.display != undefined && ball.display === false) return false;
                                return true;
                            });
                            let addedDivider = false;
                            let addedExtraDivider = false;
                            return visibleBalls.map((ball) => {
                                const val = rec.numbers[ball.id];
                                if (val === undefined || val === null || val === '') return null;

                                // Non-ball items render as "Label: Value" text
                                if (ball.isBall === false) {
                                    const label = ball.shortName || ball.Name || ball.id;
                                    const displayVal = ball.isMoney ? formatMoney(val) : val.toLocaleString ? val.toLocaleString() : val;
                                    const divider = !addedExtraDivider ? (
                                        <span key="extra-divider" style={{
                                            display: 'inline-block',
                                            width: '2px',
                                            height: '24px',
                                            background: '#ccc',
                                            marginLeft: '4px',
                                            marginRight: '8px',
                                            alignSelf: 'center'
                                        }} />
                                    ) : null;
                                    addedExtraDivider = true;
                                    return (
                                        <React.Fragment key={ball.id}>
                                            {divider}
                                            <span title={ball.Name} style={extraStyle}>
                                                <strong>{label}:</strong>&nbsp;{displayVal}
                                            </span>
                                        </React.Fragment>
                                    );
                                }

                                const isDP = /_dp/i.test(ball.id || '') || (ball.Name || '').toLowerCase().includes('double play');
                                const ballStyle = isDP
                                    ? {
                                        ...circleStyle,
                                        width: '20px',
                                        height: '20px',
                                        fontSize: '10px',
                                        lineHeight: '20px',
                                        marginRight: '3px',
                                        ...(ball.color ? { background: ball.color, color: '#333' } : {})
                                    }
                                    : ball.color
                                        ? { ...circleStyle, background: ball.color }
                                        : circleStyle;
                                const divider = (isDP && !addedDivider) ? (
                                    <span key="dp-divider" style={{
                                        display: 'inline-block',
                                        width: '2px',
                                        height: '24px',
                                        background: '#ccc',
                                        marginLeft: '4px',
                                        marginRight: '8px',
                                        alignSelf: 'center'
                                    }} />
                                ) : null;
                                if (isDP && !addedDivider) addedDivider = true;
                                return (
                                    <React.Fragment key={ball.id}>
                                        {divider}
                                        <span title={ball.Name} style={ballStyle}>
                                            {val}
                                        </span>
                                    </React.Fragment>
                                );
                            });
                        })()}
                    </div>
                );
            };

            const parseYMD = (value) => {
                if (!value) return null;

                // Accept both date-only and ISO datetime strings; grab the leading date part.
                if (typeof value === 'string') {
                    const m = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
                    if (m) {
                        const y = Number(m[1]);
                        const mo = Number(m[2]);
                        const d = Number(m[3]);
                        if (!Number.isFinite(y) || !Number.isFinite(mo) || !Number.isFinite(d)) return null;
                        return { y, mo, d };
                    }
                }

                // Fall back: if it's a Date or timestamp-ish value
                const dt = new Date(value);
                if (isNaN(dt.getTime())) return null;

                // Use UTC parts to avoid timezone shifts.
                return { y: dt.getUTCFullYear(), mo: dt.getUTCMonth() + 1, d: dt.getUTCDate() };
            };

            const ymdToISO = (ymd) => {
                if (!ymd) return '';
                const yyyy = String(ymd.y).padStart(4, '0');
                const mm = String(ymd.mo).padStart(2, '0');
                const dd = String(ymd.d).padStart(2, '0');
                return `${yyyy}-${mm}-${dd}`;
            };

            const formatDrawDate = (value) => {
                const ymd = parseYMD(value);
                if (!ymd) return value ? value : '';

                // Build a UTC date at midnight so weekday is stable across timezones.
                const utcDate = new Date(Date.UTC(ymd.y, ymd.mo - 1, ymd.d));
                const weekday = utcDate.toLocaleDateString(undefined, { weekday: 'long', timeZone: 'UTC' });

                return `${weekday} ${ymd.mo}/${ymd.d}/${ymd.y}`;
            };

            const getWeekdayFromISODate = (isoDate) => {
                // isoDate expected as YYYY-MM-DD
                const ymd = parseYMD(isoDate);
                if (!ymd) return null;

                const utcDate = new Date(Date.UTC(ymd.y, ymd.mo - 1, ymd.d));
                if (isNaN(utcDate.getTime())) return null;

                return utcDate.toLocaleDateString(undefined, { weekday: 'long', timeZone: 'UTC' });
            };

            const isEveryday = (drawDays) => {
                if (!Array.isArray(drawDays)) return false;
                const days = drawDays.filter(Boolean).map(d => d.toString().trim());
                if (days.length !== 7) return false;

                const all = new Set(days.map(d => d.toLowerCase()));
                const week = [
                    'sunday',
                    'monday',
                    'tuesday',
                    'wednesday',
                    'thursday',
                    'friday',
                    'saturday'
                ];

                return week.every(d => all.has(d));
            };

            // Ensure we always have a valid selected game when games exist
            if (gameKeys.length > 0 && (!this.state.category || gameKeys.indexOf(this.state.category) < 0)) {
                this.setState({ category: gameKeys[0] });
            }



            var dataList = []
            var WinningNumbers = JSON.parse(JSON.stringify(this.props.data.WinningNumbers.data));
            // //Filtering List
            if (Object.keys(this.state.filterBy).length > 0) {
                WinningNumbers = WinningNumbers.filter((object) => {
                    for (var prop in this.state.filterBy) {
                        if (typeof object[prop] === "undefined") return false;
                        var displayValue = (prop === 'drawDate') ? formatDrawDate(object[prop]) : object[prop].toString();
                        if (displayValue.toLowerCase().indexOf(this.state.filterBy[prop].toString().toLowerCase()) < 0) return false;
                    }
                    return true;
                });
            }
            // //Sorting List
            if (this.state.sortBy !== '') {
                WinningNumbers.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
            }

            // Filter data by selected game
            if (this.state.category !== "" && this.state.category !== undefined && this.state.category !== false) {
                WinningNumbers = WinningNumbers.filter(function (object) {
                    return object.game === this.state.category;
                }, this)
            }


            for (var data of WinningNumbers) {
                dataList.push(
                    <tr className="dataRow" onClick={this.editData(data.id)} key={data.id}>
                        <td style={{ flex: '0 0 220px', textAlign: 'left', display: 'flex', alignItems: 'center' }}>
                            {formatDrawDate(data.drawDate)}
                        </td>

                        {showDrawID ? (
                            <td style={{ flex: '0 0 180px', textAlign: 'left', display: 'flex', alignItems: 'center' }}>
                                <span>{data.drawId}</span>
                            </td>
                        ) : null}

                        <td style={{ flex: '1 0 620px', textAlign: 'left', display: 'flex', alignItems: 'center' }}>
                            {renderWinningNumbers(data)}
                        </td>

                        {/* Flags on far-right (only when importer is enabled) */}
                        {importer ? (
                            <td style={{ flex: '0 0 70px', textAlign: 'right', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', color: '#7a0019' }}>
                                    {!!data.doNotPlayOnIVR ? (
                                        <span title="Disabled on IVR" style={{ display: 'inline-flex', alignItems: 'center' }}>
                                            <FaPhoneSlash />
                                        </span>
                                    ) : null}

                                    {!!data.disableImporterUpdates ? (
                                        <span title="Importer updates disabled" style={{ display: 'inline-flex', alignItems: 'center' }}>
                                            <FaPauseCircle />
                                        </span>
                                    ) : null}
                                </span>
                            </td>
                        ) : null}
                    </tr>
                );
            }

            const safeClone = (obj) => JSON.parse(JSON.stringify(obj));

            const normalizeVal = (v) => {
                if (v === undefined || v === null) return '';
                return v;
            };

            const buildChangeSummary = (original, current, balls, formatDrawDateFn) => {
                const rows = [];

                const orig = original || null;
                const cur = current || {};

                rows.push({
                    type: 'meta',
                    label: 'Draw ID',
                    from: orig ? normalizeVal(orig.drawId) : '',
                    to: normalizeVal(cur.drawId),
                    changed: !!orig && normalizeVal(orig.drawId).toString() !== normalizeVal(cur.drawId).toString()
                });

                rows.push({
                    type: 'meta',
                    label: 'Draw Date',
                    from: orig ? formatDrawDateFn(orig.drawDate) : '',
                    to: formatDrawDateFn(cur.drawDate),
                    changed: !!orig && formatDrawDateFn(orig.drawDate).toString() !== formatDrawDateFn(cur.drawDate).toString()
                });

                const origNums = (orig && orig.numbers) ? orig.numbers : {};
                const curNums = (cur && cur.numbers) ? cur.numbers : {};

                for (const ball of balls) {
                    const id = ball.id;
                    const fromValRaw = normalizeVal(origNums[id]);
                    const toValRaw = normalizeVal(curNums[id]);

                    const formatBallVal = (v) => {
                        if (v === '') return '';
                        if (ball.isMoney) {
                            const num = Number(v);
                            if (Number.isFinite(num)) return '$' + num.toLocaleString();
                        }
                        return v.toString();
                    };

                    const fromVal = formatBallVal(fromValRaw);
                    const toVal = formatBallVal(toValRaw);

                    // If we're adding a new record, treat filled values as "changed" so they get highlighted.
                    const changed = orig ? (fromVal !== toVal) : (toVal !== '');

                    // Always show every ball (including unchanged values like 6 → 6)
                    rows.push({
                        type: 'ball',
                        label: ball.Name || id,
                        from: fromVal,
                        to: toVal,
                        changed
                    });
                }

                return rows;
            };

            var editData = "";
            if (this.state.editData && this.state.tempData) {

                const editGameKey = this.state.tempData.game;
                const editGameDef = (editGameKey && gamesObj[editGameKey]) ? gamesObj[editGameKey] : null;
                const editBalls = (editGameDef && Array.isArray(editGameDef.Balls)) ? editGameDef.Balls : [];
                console.log('editGameDef:', editGameDef);
                // --- Not Before logic for new records ---
                const notBeforeRaw = editGameDef.notBefore || null;

                let notBeforeDisplay = '';
                let hasNotBefore = false;

                if (typeof notBeforeRaw === 'string') {
                    const trimmed = notBeforeRaw.trim();

                    // Time-only format like "20:45" (24h)
                    const m = trimmed.match(/^(\d{1,2}):(\d{2})$/);
                    if (m) {
                        let hh = Number(m[1]);
                        const mm = Number(m[2]);

                        if (Number.isFinite(hh) && Number.isFinite(mm) && hh >= 0 && hh <= 23 && mm >= 0 && mm <= 59) {
                            const ampm = hh >= 12 ? 'PM' : 'AM';
                            let h12 = hh % 12;
                            if (h12 === 0) h12 = 12;

                            notBeforeDisplay = `${h12}:${String(mm).padStart(2, '0')} ${ampm}`;
                            hasNotBefore = true;
                        }
                    } else {
                        // Try parsing as a date/time string
                        const dt = new Date(trimmed);
                        if (!isNaN(dt.getTime())) {
                            notBeforeDisplay = dt.toLocaleString();
                            hasNotBefore = true;
                        }
                    }
                } else if (notBeforeRaw) {
                    // Date / timestamp
                    const dt = new Date(notBeforeRaw);
                    if (!isNaN(dt.getTime())) {
                        notBeforeDisplay = dt.toLocaleString();
                        hasNotBefore = true;
                    }
                }

                const numbers = (this.state.tempData.numbers) ? this.state.tempData.numbers : {};

                const inputElements = (
                    <div style={{ width: '100%' }}>
                        {editBalls.map((ball) => {
                            const min = (ball.Min !== undefined && ball.Min !== null) ? Number(ball.Min) : undefined;
                            const max = (ball.Max !== undefined && ball.Max !== null) ? Number(ball.Max) : undefined;
                            const rawVal = (numbers[ball.id] === undefined || numbers[ball.id] === null) ? '' : numbers[ball.id];

                            if (ball.isMoney) {
                                const displayVal = (rawVal === '' || rawVal === undefined || rawVal === null) ? '' : Number(rawVal).toLocaleString();
                                return (
                                    <div key={ball.id} style={{ width: '100%', marginBottom: '12px' }}>
                                        <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px' }}>{ball.Name}</label>
                                        <input
                                            type="text"
                                            value={displayVal}
                                            onChange={(e) => {
                                                const stripped = e.target.value.replace(/[^0-9-]/g, '');
                                                this.handleBallValueChange(ball.id, min, max)({ target: { value: stripped } });
                                            }}
                                            style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px' }}
                                        />
                                        {(min !== undefined || max !== undefined) ? (
                                            <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                                {min !== undefined ? `Min: ${min.toLocaleString()}` : ''}{(min !== undefined && max !== undefined) ? '  •  ' : ''}{max !== undefined ? `Max: ${max.toLocaleString()}` : ''}
                                            </div>
                                        ) : null}
                                    </div>
                                );
                            }

                            return (
                                <div key={ball.id} style={{ width: '100%', marginBottom: '12px' }}>
                                    <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px' }}>{ball.Name}</label>
                                    <input
                                        type="number"
                                        value={rawVal}
                                        min={min}
                                        max={max}
                                        step="1"
                                        onChange={this.handleBallValueChange(ball.id, min, max)}
                                        style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px' }}
                                    />
                                    {(min !== undefined || max !== undefined) ? (
                                        <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                            {min !== undefined ? `Min: ${min}` : ''}{(min !== undefined && max !== undefined) ? '  •  ' : ''}{max !== undefined ? `Max: ${max}` : ''}
                                        </div>
                                    ) : null}
                                </div>
                            );
                        })}
                    </div>
                );

                // Build confirm overlay if needed
                let confirmOverlay = "";
                if (this.state.confirmAction === 'save') {
                    const summary = buildChangeSummary(
                        this.state.originalTempData,
                        this.state.tempData,
                        editBalls,
                        formatDrawDate
                    );
                    const drawIdChanged = !!(this.state.originalTempData && this.state.tempData) &&
                        (normalizeVal(this.state.originalTempData.drawId).toString() !== normalizeVal(this.state.tempData.drawId).toString());

                    confirmOverlay = (
                        <div className="blackout" tabIndex="1" autoFocus onKeyUp={(e) => {
                            // ESC = back
                            if (e.keyCode === 27) this.cancelConfirm();
                            // Enter = finalize
                            if (e.keyCode === 13) this.finalizeEdit();
                        }}>
                            <div className="pop" style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                maxWidth: '520px',
                                padding: '35px'
                            }}>
                                <div className="viewCloser" onClick={this.cancelConfirm}></div>
                                <div className="error">{this.state.error}</div>

                                <h2 style={{ marginBottom: '10px', fontSize: '1.5rem', textAlign: 'center' }}>
                                    Confirm Changes
                                </h2>
                                {drawIdChanged ? (
                                    <div style={{
                                        width: '100%',
                                        marginBottom: '12px',
                                        padding: '10px 12px',
                                        borderRadius: '6px',
                                        background: '#f8d7da',
                                        border: '1px solid #f5c2c7',
                                        color: '#842029',
                                        fontWeight: 'bold'
                                    }}>
                                        Warning: You changed the Draw ID. The automated importer uses the Draw ID to decide whether a game result is new or an update. Make sure the new Draw ID matches what the importer will see from the source, or you could accidentally create duplicate draws or miss future updates.
                                    </div>
                                ) : null}
                                {this.state.tempData && this.state.tempData.disableImporterUpdates ? (
                                    <div style={{
                                        width: '100%',
                                        marginBottom: '12px',
                                        padding: '10px 12px',
                                        borderRadius: '6px',
                                        background: '#fff3cd',
                                        border: '1px solid #ffe8a1',
                                        color: '#6c4a00',
                                        fontWeight: 'bold'
                                    }}>
                                        Any future updates for this game will not be taken.
                                    </div>
                                ) : null}

                                <div style={{
                                    width: '100%',
                                    maxHeight: '360px',
                                    overflowY: 'auto',
                                    border: '1px solid #eee',
                                    borderRadius: '6px',
                                    padding: '12px'
                                }}>
                                    {summary.map((r, idx) => (
                                        <div
                                            key={idx}
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                padding: '6px 0',
                                                borderBottom: idx === summary.length - 1 ? 'none' : '1px solid #f2f2f2'
                                            }}
                                        >
                                            <div style={{ fontWeight: 'bold', marginRight: '12px' }}>{r.label}</div>
                                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                                {r.from !== '' ? <span style={{ color: '#666' }}>{r.from}</span> : <span style={{ color: '#aaa' }}>—</span>}
                                                <span style={{ color: '#999' }}>→</span>
                                                <span
                                                    style={r.changed ? {
                                                        background: '#fff3cd',
                                                        border: '1px solid #ffe8a1',
                                                        padding: '2px 8px',
                                                        borderRadius: '10px',
                                                        fontWeight: 'bold'
                                                    } : {}}
                                                >
                                                    {r.to !== '' ? r.to : <span style={{ color: '#aaa' }}>—</span>}
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div style={{ display: 'flex', gap: '10px', marginTop: '18px' }}>
                                    <button
                                        className="button"
                                        onClick={this.cancelConfirm}
                                        style={{ border: 'none', cursor: 'pointer' }}
                                    >
                                        Back
                                    </button>

                                    <button
                                        className="button"
                                        onClick={this.finalizeEdit}
                                        style={{ border: 'none', cursor: 'pointer' }}
                                    >
                                        Confirm Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                }

                if (this.state.confirmAction === 'delete') {
                    const summary = buildChangeSummary(
                        this.state.originalTempData,
                        this.state.tempData,
                        editBalls,
                        formatDrawDate
                    );

                    confirmOverlay = (
                        <div className="blackout" tabIndex="1" autoFocus onKeyUp={(e) => {
                            if (e.keyCode === 27) this.cancelConfirm();
                            if (e.keyCode === 13) this.finalizeDelete();
                        }}>
                            <div className="pop" style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                maxWidth: '520px',
                                padding: '35px'
                            }}>
                                <div className="viewCloser" onClick={this.cancelConfirm}></div>
                                <div className="error">{this.state.error}</div>

                                <h2 style={{ marginBottom: '10px', fontSize: '1.5rem', textAlign: 'center' }}>
                                    Confirm Delete
                                </h2>

                                <div style={{
                                    width: '100%',
                                    marginBottom: '12px',
                                    padding: '10px 12px',
                                    borderRadius: '6px',
                                    background: '#f8d7da',
                                    border: '1px solid #f5c2c7',
                                    color: '#842029',
                                    fontWeight: 'bold'
                                }}>
                                    This will permanently delete this drawing record.
                                </div>

                                <div style={{
                                    width: '100%',
                                    maxHeight: '360px',
                                    overflowY: 'auto',
                                    border: '1px solid #eee',
                                    borderRadius: '6px',
                                    padding: '12px'
                                }}>
                                    {summary.map((r, idx) => (
                                        <div
                                            key={idx}
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                padding: '6px 0',
                                                borderBottom: idx === summary.length - 1 ? 'none' : '1px solid #f2f2f2'
                                            }}
                                        >
                                            <div style={{ fontWeight: 'bold', marginRight: '12px' }}>{r.label}</div>
                                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                                {r.to !== '' ? <span style={{ color: '#111' }}>{r.to}</span> : <span style={{ color: '#aaa' }}>—</span>}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div style={{ display: 'flex', gap: '10px', marginTop: '18px' }}>
                                    <button
                                        className="button"
                                        onClick={this.cancelConfirm}
                                        style={{ border: 'none', cursor: 'pointer' }}
                                    >
                                        Back
                                    </button>

                                    <button
                                        className="button"
                                        onClick={this.finalizeDelete}
                                        style={{ border: 'none', cursor: 'pointer', background: '#b02a37', color: '#fff' }}
                                    >
                                        Confirm Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                }

                // Your existing edit modal (unchanged except button behavior)
                const editModal = (
                    <div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
                        <div className="pop" style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            maxWidth: '420px',
                            padding: '45px'
                        }}>
                            <div className="viewCloser" onClick={this.cancel}></div>
                            <div className="error">{this.state.error}</div>

                            <h2 style={{ marginBottom: '6px', fontSize: '1.5rem', textAlign: 'center' }}>
                                {editGameDef && editGameDef.Name ? editGameDef.Name : editGameKey}
                            </h2>

                            <div style={{ width: '100%', marginBottom: '18px', fontSize: '14px', color: '#666' }}>
                                {showDrawID ? (
                                    <div style={{ marginBottom: '10px' }}>
                                        <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px', color: '#333' }}>Draw ID</label>
                                        <input
                                            type="text"
                                            value={this.state.tempData.drawId || ''}
                                            onChange={this.handleDrawIdChange}
                                            style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px' }}
                                        />
                                    </div>
                                ) : null}

                                <div>
                                    <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px', color: '#333' }}>
                                        Draw Date
                                    </label>

                                    <DatePicker
                                        selected={(() => {
                                            const ymd = parseYMD(this.state.tempData.drawDate);
                                            if (!ymd) return null;
                                            // Create a local Date so the calendar lines up with the stored YYYY-MM-DD
                                            return new Date(ymd.y, ymd.mo - 1, ymd.d);
                                        })()}
                                        onChange={(date) => {
                                            if (!date) {
                                                this.setState({ error: '' });
                                                this.handleDrawDateChange({ target: { value: '' } });
                                                return;
                                            }

                                            // Build a date-only string in local time so there is no off-by-one shift
                                            const year = date.getFullYear();
                                            const month = String(date.getMonth() + 1).padStart(2, '0');
                                            const day = String(date.getDate()).padStart(2, '0');
                                            const isoLocal = `${year}-${month}-${day}`;

                                            this.setState({ error: '' });
                                            this.handleDrawDateChange({ target: { value: isoLocal } });
                                        }}
                                        filterDate={(date) => {
                                            if (!editGameDef || !Array.isArray(editGameDef.drawDays)) return true;

                                            const weekday = date.toLocaleDateString(undefined, {
                                                weekday: 'long',
                                                timeZone: 'UTC'
                                            });

                                            return editGameDef.drawDays.includes(weekday);
                                        }}
                                        placeholderText="Select draw date"
                                        dateFormat="yyyy-MM-dd"
                                        maxDate={new Date()}
                                        className="react-datepicker-input"
                                        wrapperClassName="react-datepicker-wrapper-250"
                                        customInput={
                                            <input
                                                style={{
                                                    width: '250px',
                                                    padding: '8px',
                                                    border: '1px solid #999',
                                                    borderRadius: '4px'
                                                }}
                                            />
                                        }
                                    />
                                    <div style={{ fontSize: '12px', color: '#888', marginTop: '6px' }}>
                                        Current: {formatDrawDate(this.state.originalTempData && this.state.originalTempData.drawDate)}
                                    </div>
                                    {(editGameDef && Array.isArray(editGameDef.drawDays) && editGameDef.drawDays.length > 0) ? (
                                        <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>
                                            Allowed days: {isEveryday(editGameDef.drawDays) ? 'Everyday' : editGameDef.drawDays.join(', ')}
                                        </div>
                                    ) : null}

                                </div>
                            </div>

                            {inputElements}
                            {/* Disable Importer Updates */}
                            {importer ? (
                                <div
                                    style={{
                                        marginTop: '16px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '12px',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '100%',
                                            padding: '12px 18px',
                                            borderRadius: '6px',
                                            border: '1px solid #ddd',
                                            boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
                                            background: '#fafafa',
                                            textAlign: 'left'
                                        }}
                                    >
                                        <label
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                cursor: 'pointer',
                                                color: '#333',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={!!(this.state.tempData && this.state.tempData.disableImporterUpdates)}
                                                onChange={this.handleDisableImporterUpdatesChange}
                                            />
                                            Disable importer updates
                                        </label>

                                        <div
                                            style={{
                                                fontSize: '12px',
                                                color: '#777',
                                                marginTop: '6px',
                                                marginLeft: '26px',
                                                maxWidth: '260px'
                                            }}
                                        >
                                            Prevents the automated importer from updating this game going forward.
                                        </div>
                                    </div>

                                    {/* Do Not Play on IVR */}
                                    <div
                                        style={{
                                            width: '100%',
                                            padding: '12px 18px',
                                            borderRadius: '6px',
                                            border: '1px solid #ddd',
                                            boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
                                            background: '#fafafa',
                                            textAlign: 'left'
                                        }}
                                    >
                                        <label
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                cursor: 'pointer',
                                                color: '#333',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={!!(this.state.tempData && this.state.tempData.doNotPlayOnIVR)}
                                                onChange={this.handleDoNotPlayOnIVRChange}
                                            />
                                            Do not play on IVR
                                        </label>

                                        <div
                                            style={{
                                                fontSize: '12px',
                                                color: '#777',
                                                marginTop: '6px',
                                                marginLeft: '26px',
                                                maxWidth: '260px'
                                            }}
                                        >
                                            This record will no longer be heard on the IVR either as the latest winning number or via the search feature.
                                        </div>
                                    </div>
                                </div>) : null}
                            {/* Not Before Helper Block */}
                            {!this.state.originalTempData && hasNotBefore ? (
                                <div
                                    style={{
                                        width: '100%',
                                        marginTop: '18px',
                                        padding: '10px 12px',
                                        borderRadius: '6px',
                                        background: '#fff3cd',
                                        border: '1px solid #ffe8a1',
                                        color: '#6c4a00',
                                        fontWeight: 'bold',
                                        textAlign: 'center'
                                    }}
                                >
                                    Drawings cannot be entered before: {notBeforeDisplay}
                                </div>
                            ) : null}
                            <button
                                className="button"
                                onClick={() => this.confirmEdit('save')}
                                style={{ border: 'none', cursor: 'pointer', marginTop: '18px', width: '250px' }}
                            >
                                Confirm
                            </button>
                            {deleteOption && this.state.originalTempData && this.state.originalTempData.id ? (
                                <button
                                    className="button"
                                    onClick={() => this.confirmEdit('delete')}
                                    style={{
                                        border: 'none',
                                        cursor: 'pointer',
                                        marginTop: '10px',
                                        background: '#b02a37',
                                        color: '#fff',
                                        width: '250px'
                                    }}
                                >
                                    Delete
                                </button>
                            ) : null}
                        </div>
                    </div>
                );

                editData = (
                    <>
                        {editModal}
                        {confirmOverlay}
                    </>
                );
            }






            var addButton = ""

            addButton = <AddButton onClick={this.addWinningNumber} />

            return (
                <div width="100%">
                    {addButton}
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <div style={{ width: '200px', marginRight: '50px', marginTop: '2px' }}>
                            <div style={{ display: 'flex', alignItems: 'left', marginBottom: '20px', marginTop: '10px' }}>
                                <label className="switch">
                                    <div style={{ width: '250px' }}>

                                        <select
                                            value={this.state.category}
                                            onChange={this.checkCategory}
                                            style={{
                                                display: 'inline-block',
                                                flex: '1 0 0',
                                                marginBottom: '5px',
                                                height: '40px',
                                                padding: '0 10px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                fontWeight: 'bold',
                                                fontSize: '20px',
                                                color: '#137',
                                                lineHeight: '24px'
                                            }}
                                        >
                                            {gameKeys.map((gameKey) => (
                                                <option key={gameKey} value={gameKey}>
                                                    {gamesObj[gameKey] && gamesObj[gameKey].Name ? gamesObj[gameKey].Name : gameKey}
                                                </option>
                                            ))}
                                        </select>

                                    </div>
                                </label>
                            </div>
                            <div className="filterBox" style={{
                                "width": "210px"
                            }}>

                                <h4>Filter By:</h4>
                                {showDrawID ? (
                                    <div style={{ width: '150px' }}>
                                        <label>Draw ID:</label>
                                        <input type="text" onChange={this.filter("drawId")} value={this.state.filterBy.drawId || ''} />
                                    </div>
                                ) : null}
                                <div style={{ width: '150px' }}>
                                    <label>Draw Date:</label>
                                    <input type="text" onChange={this.filter("drawDate")} value={this.state.filterBy.drawDate || ''} />
                                </div>
                            </div>
                        </div>
                        <div style={{ flex: 1 }}>
                            <table style={{ width: "100%" }}>
                                <thead>
                                    <tr className="dataRow">
                                        <th style={{ flex: '0 0 220px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("drawDate")}>Draw Date {this.filterIcon("drawDate")}</th>
                                        {showDrawID ? <th style={{ flex: '0 0 180px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("drawId")}>Draw ID {this.filterIcon("drawId")}</th> : null}
                                        <th style={{ flex: '1 0 620px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("game")}>Winning Numbers {this.filterIcon("game")}</th>
                                        {importer ? <th style={{ flex: '0 0 70px', textAlign: 'right' }}> </th> : null}
                                    </tr>
                                </thead>
                                <tbody>
                                    {dataList}
                                </tbody>
                            </table>
                        </div>
                    </div >
                    {editData}
                </div >
            );
        } else {
            return (
                <div width="100%">

                </div>
            );
        }
    }
}


const icon = "menuStar"
const roles = ["View"]
export { WinningNumbers, icon, roles }